import axios from "axios"
import settings from "settings"
import userToken from "helpers/userToken"

export default async function (path, data) {
	try {
		let user = userToken()
		const response = await axios.post( settings.ep + '/' + path, data, { headers: { Authorization: `Bearer ${user}` } })
		if (response.data.status == 200) {
			return response.data
		} else {
			let err = new Error()
			err.message = response.data.message
			err.status = response.data.status
			return err
		}
	} catch (error) {
		console.error(error)
	}
}
